module.exports = __webpack_public_path__ + "media/images/jumping/jumper-class-b6a10e89272e20bb63e6825f15e1e8d2.jpg";